import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Card } from "@mostlycode/ui"

const StyledCookies = styled.span`
  position: fixed;
  bottom: 1rem;
  max-width: 60rem;
  left: 1rem;
  width: 4rem;
  height: 4rem;
`

function Cookies({ children, ...props }) {
  return (
    <StyledCookies {...props}>
      <span></span>
    </StyledCookies>
  )
}

export default Cookies

Cookies.defaultProps = {}
Cookies.propTypes = {
  children: PropTypes.node.isRequired,
}
